import { render, staticRenderFns } from "./UserTransfer.vue?vue&type=template&id=ce0e6c6e&scoped=true&"
import script from "./UserTransfer.vue?vue&type=script&lang=js&"
export * from "./UserTransfer.vue?vue&type=script&lang=js&"
import style0 from "./UserTransfer.vue?vue&type=style&index=0&id=ce0e6c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0e6c6e",
  null
  
)

export default component.exports